<template>
  <div class="goods">
    <v-head :title="title"></v-head>
    <ul id="normaltab1" class="tabbtn">
      <li :class="{'current': isSelect === 0}" @click="isSelect = 0">
        <a>全部通告</a>
      </li>
      <li :class="{'current': isSelect === 1}" @click="isSelect = 1">
        <a>本会通告</a>
      </li>
    </ul>
    <div class="personal">
      <div class="warmTip" v-if="tableData.content && tableData.content.length<1">
        <img src="@/assets/images/404.png" />
        <span>没有找到相应内容哦</span>
      </div>
      <ul class="ul-imgtxt2">
        <li v-for="(notice,index) in tableData.content" :key="index">
          <div class="txt" @click="goDetail(notice.id)">
            <h3 class="tit">{{notice.title}}</h3>
            <span class="time">{{notice.releaseTime}}</span>
            <div class="c"></div>
            <p>{{intercept(notice.content)}}</p>
          </div>
        </li>
      </ul>
      <!-- <div class="page">
        <el-pagination
        background
        layout="prev, pager, next"
        :total="tableData.totalElements">
        </el-pagination>
    </div> -->
    </div>
  </div>
</template>

<script type="text/javascript">
  import { noticeList } from "@/api/dictionary";
  import vHead from "../../../components/Subhead";
  import { getSessionStore } from "@/utils/sessionStorage.js"
  import { mapState } from "vuex";

  export default {
    data() {
      return {
        page: 1,
        isSelect: 0,
        tableData: [],
        title: ""
      };
    },
    components: {
      vHead,
    },
    computed: {
      ...mapState(["userInfo"]),
    },
    watch: {
      isSelect() {
        this.getData();
      }
    },
    methods: {
      goDetail(id) {
        this.$router.push({ name: "noticeDetails", query: { noticeId: id } });
      },
      getData() {
        let params = {
          branchCode: this.userInfo.recommendUnitId,
          auditStatus: 1
        }
        if (this.isSelect == 0) {
          delete (params.branchCode);
        }
        noticeList(params, this.page - 1).then(res => {
          if (res.success) {
            this.tableData = res.result;
          } else {
            this.$message.error(res.message);
          }
        });
      },
      intercept(item) {
        let reg = new RegExp(/<[^>]+>/g);
        if (item) {
          let content = item.replace(reg, "");
          return content;
        }
      },
    },
    mounted() {
      this.getData()
    }
  };
</script>

<style scoped lang="less">
  .tabbtn {
    width: 75%;
    display: block;
    overflow: hidden;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 999;
  }

  .tabbtn li {
    text-align: center;
    font-size: 15px;
    float: left;
    padding: 25px 0 15px 0;
    margin: 0 20px;
  }

  .tabbtn li.current {
    border-bottom: #378be1 solid 2px;
  }

  .tabbtn li.current a {
    color: #378be1;
  }

  .personal {
    padding: 0 15px;
  }

  .ul-imgtxt2 {
    width: 100%;
    margin: 0 auto;
  }

  .ul-imgtxt2 li {
    border-bottom: 1px solid #efefef;
    padding-bottom: 20px;
    margin-top: 20px;
    color: #333;
  }

  .ul-imgtxt2 li:hover {
    cursor: pointer;
    color: #1989fa;
  }

  .ul-imgtxt2 li .pic img {
    display: block;
    width: 100%;
    height: 100%;
  }

  .ul-imgtxt2 .txt .tit {
    font-size: 16px;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 1px 0;
    overflow: hidden;
  }

  .ul-imgtxt2 .txt .time {
    display: block;
    margin: 15px 0;
    font-size: 14px;
    color: #86889a;
    min-height: 13px;
  }

  .c {
    clear: both;
  }

  .ul-imgtxt2 .txt p {
    font-size: 15px;
    color: #666;
    line-height: 1.5em;
    max-height: 3em;
    overflow: hidden;
  }

  .page {
    text-align: center;
    margin-top: 30px;
  }
</style>